import type { DeviceType } from '@/api/client'
import { BarBackgroundStyle } from '@/composables/useNativeStyle'
import type { areas } from '@/router/areas'
import type {
  RouteComponent,
  RouteLocationNormalizedLoaded,
  RouteRecordRaw,
} from 'vue-router'

export function deviceType(
  deviceType: DeviceType[],
  routes: Array<RouteRecordRaw>,
) {
  return routes.map((route) => {
    if (route.meta) {
      route.meta.device_type = deviceType
    } else {
      route.meta = { device_type: deviceType }
    }
    return route
  })
}

export function area(area: areas, routes: Array<RouteRecordRaw>) {
  return routes.map((route) => {
    if (route.meta) {
      route.meta.area = area
    } else {
      route.meta = { area }
    }
    return route
  })
}

export function layout(pathRelativeToPagesFolder: string) {
  // dynamic imports have limitations
  // see https://vitejs.dev/guide/features.html#dynamic-import
  const parts = pathRelativeToPagesFolder.split('/')
  type TypeLazyCompontent = () => Promise<RouteComponent>
  let lazyComponent: TypeLazyCompontent

  if (parts.length === 1) {
    lazyComponent = () => import(`../../layouts/${parts[0]}.vue`)
  } else if (parts.length === 2) {
    lazyComponent = () => import(`../../layouts/${parts[0]}/${parts[1]}.vue`)
  } else if (parts.length === 3) {
    lazyComponent = () =>
      import(`../../layouts/${parts[0]}/${parts[1]}/${parts[2]}.vue`)
  } else if (parts.length === 4) {
    lazyComponent = () =>
      import(
        `../../layouts/${parts[0]}/${parts[1]}/${parts[2]}/${parts[3]}.vue`
      )
  } else {
    throw Error('page() called with invalid path: ' + pathRelativeToPagesFolder)
  }
  return lazyComponent
}

export function page(pathRelativeToPagesFolder: string) {
  // dynamic imports have limitations
  // see https://vitejs.dev/guide/features.html#dynamic-import
  const parts = pathRelativeToPagesFolder.split('/')
  type TypeLazyCompontent = () => Promise<RouteComponent>
  let lazyComponent: TypeLazyCompontent

  if (parts.length === 1) {
    lazyComponent = () => import(`../../pages/${parts[0]}.vue`)
  } else if (parts.length === 2) {
    lazyComponent = () => import(`../../pages/${parts[0]}/${parts[1]}.vue`)
  } else if (parts.length === 3) {
    lazyComponent = () =>
      import(`../../pages/${parts[0]}/${parts[1]}/${parts[2]}.vue`)
  } else if (parts.length === 4) {
    lazyComponent = () =>
      import(`../../pages/${parts[0]}/${parts[1]}/${parts[2]}/${parts[3]}.vue`)
  } else {
    throw Error('page() called with invalid path: ' + pathRelativeToPagesFolder)
  }

  return lazyComponent
}

export function getRouteBarBackgroundStyles(
  route: RouteLocationNormalizedLoaded,
) {
  return {
    statusBar:
      route.meta?.statusBarBackgroundStyle !== undefined
        ? route.meta.statusBarBackgroundStyle
        : BarBackgroundStyle.WHITE,
    navigationBar:
      route.meta?.navigationBarBackgroundStyle !== undefined
        ? route.meta.navigationBarBackgroundStyle
        : BarBackgroundStyle.WHITE,
  }
}
